export default class MapRoutes {
	constructor(route) {
		if (!route) return;
		this.routeContainer = route;
		this.init();
		this.events();
		this.afterInit();
	}

	afterInit() {
		this.button.dispatchEvent(new Event("click"));
	}

	init() {
		this.button = this.routeContainer.querySelector("[data-map-origin]");
	}

	onButtonClicked(ev) {
		if (this.button.dataset?.mapOrigin && this.button.dataset?.mapDestination) {
			window.dispatchEvent(
				new CustomEvent("gmap.calculateAndDisplayRoute", {
					detail: {
						origin: this.button.dataset.mapOrigin,
						destination: this.button.dataset.mapDestination,
						container: this.routeContainer,
					},
				})
			);
		}
	}

	onGetResponse(ev) {
		if (ev.detail?.extra?.container === this.routeContainer) {
			// console.log(ev.detail);
			ev.detail.response.distance.text &&
				(this.routeContainer.querySelector(".distance").textContent =
					ev.detail.response.distance.text);
			ev.detail.response.duration.text &&
				(this.routeContainer.querySelector(".duration").textContent =
					ev.detail.response.duration.text);
		}
	}

	events() {
		this.button.addEventListener(
			"click",
			this.onButtonClicked.bind(this),
			false
		);

		window.addEventListener(
			"gmap.responseRoute",
			this.onGetResponse.bind(this),
			false
		);
	}
}
